import { objectSpread2 as _objectSpread2 } from "../_virtual/_rollupPluginBabelHelpers.js";
import { EVENT } from "xgplayer-streaming-shared";
var Event = _objectSpread2(_objectSpread2({}, EVENT), {}, {
  STREAM_PARSED: "core.streamparsed",
  NO_AUDIO_TRACK: "core.noaudiotrack",
  SUBTITLE_SEGMENTS: "core.subtitlesegments",
  SUBTITLE_PLAYLIST: "core.subtitleplaylist",
  SEI_PAYLOAD_TIME: "core.seipayloadtime"
});
export { Event };
